import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Notes affordance. Prefer `href` (opens in new tab like the proto) over `onClick`.
 */
export function NotesIconButton({ hasNotes, onClick, href, memberLabel }) {
  const label = hasNotes
    ? `View notes for ${memberLabel || 'member'}`
    : `Add notes for ${memberLabel || 'member'}`;

  const icon = (
    <svg className="onyx-notes-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M4.5 2.5h7a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z" fill="none" stroke="currentColor" strokeWidth="1.25" />
      <path d="M5.5 5.5h5M5.5 8h5M5.5 10.5h3" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );

  if (href) {
    return (
      <Tooltip title={label}>
        <IconButton
          component="a"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          className={`onyx-notes-icon-btn${hasNotes ? ' has-notes' : ''}`}
          aria-label={label}
          data-testid="onyx-notes-icon"
          data-no-copy
          onClick={(e) => e.stopPropagation()}
        >
          {icon}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        className={`onyx-notes-icon-btn${hasNotes ? ' has-notes' : ''}`}
        onClick={onClick}
        aria-label={label}
        data-testid="onyx-notes-icon"
        data-no-copy
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
}

NotesIconButton.propTypes = {
  hasNotes: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  memberLabel: PropTypes.string,
};
